import { theme } from '../../theme'
import styled from 'particles/themes/styled'
import Loading from 'components/Loading'

export const SubmissionsLayout = styled.div`
    display: grid;
    grid-gap: ${theme.gutter.s} !important;
    grid-template-columns: repeat(auto-fit, 1fr);
    @media screen and (min-width: 375px) {
        grid-gap: ${theme.gutter.xs};
        grid-template-columns: repeat(1, minmax(343px, 1fr));
    };
    @media screen and (min-width: 768px) {
        grid-template-columns: repeat(1, minmax(720px, 1fr));
    };
    @media screen and (min-width: 1280px) {
        grid-template-columns: repeat(2, minmax(604px, 1fr));
    };
    @media screen and (min-width: 1500px) {
        grid-template-columns: repeat(3, minmax(448px, 1fr));
    },
`

export const SecondHeader = styled.div<{ justifyContent?: string }>`
    width: 100%;
    max-width: 1920px;
    margin: 16px auto 0;
    display: flex;
    justify-content: ${({ justifyContent }) => justifyContent || 'flex-end'};
    flex-wrap: wrap;
    box-sizing: border-box;
    @media screen and (max-width: 375px) {
        padding: 0 1rem;
    }
`
export const StyledLoading = styled(Loading)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50%;
`
